import React, { FC } from 'react'
import { Card } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { getUserPasswordControlDescriptors } from '../helpers'
import { buildControlsExt } from '../../../inputs/controls'

interface IUserPassword {
    isReadOnly: boolean
    inputState: any
    setInputState: any
    touched: any
    setTouched: any
    validationResult: any
    className?: string
}

export const UserPassword: FC<IUserPassword> = ({
    isReadOnly,
    inputState,
    setInputState,
    touched,
    setTouched,
    validationResult,
    className,
}) => {
    const controlDescriptors = getUserPasswordControlDescriptors(inputState)
    const passwordInputs = buildControlsExt(
        controlDescriptors,
        inputState,
        setInputState,
        touched,
        setTouched,
        validationResult
    )

    return (
        <>
            {!isReadOnly && (
                <Card.Body className={`${className} pb-4`}>
                    <p className="navi-blue mb-4 h5">
                        <FormattedMessage id="user.userData.changePassword" />
                    </p>
                    <div id="example-collapse-text">{passwordInputs}</div>
                </Card.Body>
            )}
        </>
    )
}
